'use strict';

exports.__esModule = true;
exports.media = exports.sizes = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    @media (min-width: ', 'px) {\n      ', ';\n    }\n  '], ['\n    @media (min-width: ', 'px) {\n      ', ';\n    }\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    @media (max-width: ', 'px) {\n      ', ';\n    }\n  '], ['\n    @media (max-width: ', 'px) {\n      ', ';\n    }\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    @media (min-width: ', 'px) and (max-width: ', 'px) {\n      ', ';\n    }\n  '], ['\n    @media (min-width: ', 'px) and (max-width: ', 'px) {\n      ', ';\n    }\n  ']);

var _styledComponents = require('styled-components');

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/*

# USAGE

import { css } from 'styled-components'
import { media } from '../../styles/mixins/media'

const MyStyledComponent = styled.div`
  color: red;
  height: 100px;

  ${media.up('desktop')`height: 500px`}
  ${media.between('tablet', 'desktop')`height: 50px`}
  ${media.down('phone')`height: 10px`}
`

Info: https://github.com/styled-components/styled-components/blob/master/docs/tips-and-tricks.md#more-powerful-example
*/

var sizes = exports.sizes = {
  giant: 1200,
  desktop: 992,
  tablet: 768,
  phone: 576
};

var media = exports.media = {
  up: function up(label) {
    return function () {
      return (0, _styledComponents.css)(_templateObject, sizes[label], _styledComponents.css.apply(undefined, arguments));
    };
  },
  down: function down(label) {
    return function () {
      return (0, _styledComponents.css)(_templateObject2, sizes[label] - 1, _styledComponents.css.apply(undefined, arguments));
    };
  },
  between: function between(minimumSize, maximumSize) {
    return function () {
      return (0, _styledComponents.css)(_templateObject3, sizes[minimumSize], sizes[maximumSize], _styledComponents.css.apply(undefined, arguments));
    };
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/qu-react-sdk/lib/styles/mixins/media.js
// module id = 32
// module chunks = 0